
import { Navigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import PageLayout from '@/components/layout/PageLayout';
import { useAuth } from '@/contexts/AuthContext';

export default function PendingApproval() {
  const { user, profile, isLoading, signOut } = useAuth();

  // If still loading, show loading state
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  // If user is not logged in, redirect to login page
  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  // If user is approved, redirect to home page
  if (profile?.is_approved) {
    return <Navigate to="/" replace />;
  }

  return (
    <PageLayout>
      <div className="container max-w-md mx-auto py-16">
        <div className="bg-yellow-50 p-8 rounded-lg border border-yellow-200 text-center space-y-6">
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-yellow-800">Account Pending Approval</h1>
            <p className="text-yellow-700">
              Thank you for registering! Your account is pending approval by an administrator.
              Please check back later.
            </p>
          </div>
          
          <div className="space-y-4">
            <p className="text-sm text-yellow-600">
              Once your account is approved, you'll be able to access all member features.
            </p>
            
            <Button variant="outline" onClick={() => signOut()}>
              Sign Out
            </Button>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
